import angular from 'angular';
import NgsTicketsApiService from './ngsTicketsApiService';
import NgsTicketsManagerService from './ngsTicketsManagerService';

/**
 * @ngdoc overview
 * @name 7Shop.NgsTickets
 *
 * @description
 * It manages ticket actions for products integrated with external platforms (e.g. L6 web iframe).
 * It uses NGS API instead of Betslip API for ticket actions.
 */
const moduleName = angular
  .module('7Shop.NgsTickets', ['SevenClient.Config'])
  .service('NgsTicketsApiService', NgsTicketsApiService)
  .service('NgsTicketsManagerService', NgsTicketsManagerService)
  .name;

export default moduleName;
